import en from 'react-phone-number-input/locale/en.json';
import es from 'react-phone-number-input/locale/es.json';
import fr from 'react-phone-number-input/locale/fr.json';
import nl from 'react-phone-number-input/locale/nl.json';
import ptBR from 'react-phone-number-input/locale/pt-BR.json';

const PHONE_COUNTRY_LOCALES = {
  en,
  'en-US': en,
  es,
  'es-MX': es,
  'es-CO': es,
  'es-PE': es,
  'pt-BR': ptBR,
  fr,
  'fr-FR': fr,
  nl,
  'nl-NL': nl,
};

/**
 * Returns country name map for the phone country selector.
 *
 * @param {string} [appLocale] - App i18n locale (e.g. 'es-MX', 'en-US').
 * @returns {Record<string, string>} Country code to localized name map.
 */
const getPhoneCountryNames = (appLocale) => PHONE_COUNTRY_LOCALES[appLocale] || en;

export default getPhoneCountryNames;
